import { render, staticRenderFns } from "./Footer.global.vue?vue&type=template&id=ad534592&scoped=true&lang=pug&"
import script from "./Footer.global.vue?vue&type=script&lang=ts&"
export * from "./Footer.global.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.global.vue?vue&type=style&index=0&id=ad534592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad534592",
  null
  
)

export default component.exports